<ng-container *ngIf="useContainer; else plainBody">
    <ph-card [heading]="displayPaymentDetails ? 'Review' : 'Review invoice details'" fill flat [narrow]="narrow">
        <ng-container *ngTemplateOutlet="body"></ng-container>
    </ph-card>
</ng-container>
<ng-template #plainBody>
    <ng-container *ngTemplateOutlet="body"></ng-container>
</ng-template>

<ng-template #body>
  <ph-stack>
    <ph-facts [attr.heading]="useContainer && !displayPaymentDetails ? null : 'Invoice details'" value-align="end" label-width="150px">
        <ph-fact>
            <ph-label>Vendor</ph-label>
            <div>{{ payable.vendor?.name }}</div>
        </ph-fact>
        <ph-fact>
            <ph-label>Invoice #</ph-label>
            <div>{{ payable.invoiceNumber ?? '--' }}</div>
        </ph-fact>
        <ph-fact>
            <ph-label>Invoice Date</ph-label>
            <div>{{ payable.invoiceDate | legfiDate:'MM/DD/YYYY' }}</div>
        </ph-fact>
        <ph-fact>
            <ph-label>Due Date</ph-label>
            <div>{{ payable.dueDate | legfiDate:'MM/DD/YYYY' }}</div>
        </ph-fact>
        <ph-fact>
            <ph-label>Memo</ph-label>
            <div>{{ payable.memo ?? '--' }}</div>
        </ph-fact>
        <ph-fact *ngFor="let category of payable.expenseCategories; trackBy: trackByExpenseCategoryId">
            <ph-label>{{ category.expenseCategory.label }}</ph-label>
            <div>{{ category.amount ?? category.expenseCategoryAmount | legfiCurrency:'USD':'symbol':'.2' }}</div>
        </ph-fact>
        <ph-fact total>
            <ph-label>Total due</ph-label>
            <div>{{ payable.amount | legfiCurrency:'USD':'symbol':'.2' }}</div>
        </ph-fact>
    </ph-facts>

    <ng-container *ngIf="payable && displayPaymentDetails">
        <ph-facts heading="Payment details" value-align="end" label-width="150px">
            <ph-fact>
                <ph-label>Payment method</ph-label>
                <div>{{ paymentMethodDescription }}</div>
            </ph-fact>
            <ph-fact>
                <ph-label>Payment date *</ph-label>
                <div>{{ paymentDateDescription }}</div>
            </ph-fact>
        </ph-facts>
        <ph-hint *ngIf="disclaimerText.length > 0">{{ disclaimerText }}</ph-hint>
    </ng-container>
  </ph-stack>
</ng-template>
